type ModuleName =
	| 'admin'
	| 'workflow'
	| 'media'
	| 'collections'
	| 'brands'
	| 'news'
	| 'account'
	| 'login'
	| 'guidelines'
	| 'templating'
	| 'styleguide'
	| 'group'
	| 'cockpit'
	| 'taxonomy'
	| 'pod'
	| 'share';

type ViewName =
	| 'job/overview'
	| 'job/view'
	| 'main/index'
	| 'campaign/overview'
	| 'campaign/dashboard'
	| 'campaign/calendar'
	| 'view'
	| 'dashboard';

export const isColdfusion = () => {
	return Boolean(window?.bynder?.Locale);
};

export const isModule = (moduleName: ModuleName) => {
	return (
		moduleName.toLowerCase() === (window.location.pathname.split('/')[1] || '').toLowerCase()
	);
};

export const getCollectionIdFromPath = () => {
	const { pathname } = window.location;
	const keyUrl = 'collections/view/';
	const keyUrlIndex = pathname.indexOf(keyUrl);

	if (keyUrlIndex === -1) {
		return '';
	}

	const idIndex = keyUrlIndex + keyUrl.length;

	return pathname.slice(idIndex).split('/')[0];
};

export const isView = (viewName: ViewName) => {
	return window.location.pathname
		.split('/')
		.slice(2)
		.join('/')
		.toLowerCase()
		.includes(viewName.toLowerCase());
};

export const isMainView = () => {
	return window.location.pathname.split('/').slice(2)[0] === '';
};

export const isCollectionDetailView = () => {
	return (
		window.location.pathname.startsWith('/collections/view/') || // Regular collection detail view
		window.location.pathname.startsWith('/web/') || // Public collection detail view
		window.location.pathname.startsWith('/share/') // Shared collection detail view
	);
};

/*
	When a portal has the App Access "Homepage (new)" enabled and has published a Brand Guidelines Homepage, the URL is "/guidelines/home"
	In the rest of the cases, the homepage URL is "/account/dashboard".
	In this function, we use 'startsWith' to avoid issues with trailing slashes in the pathname
*/
export const isHomepageView = () => {
	return (
		window.location.pathname.startsWith('/account/dashboard') ||
		window.location.pathname.startsWith('/guidelines/home')
	);
};

export const navigateTo = (href: string | undefined, target = '_self') => {
	if (href) {
		window.open(href, target);
	}
};

// Only collection pages that a logged-out user can open.
export const isPublicOrShareCollectionView = () => {
	return (
		window.location.pathname.startsWith('/web/') ||
		window.location.pathname.startsWith('/share/')
	);
};
